import merge from 'deepmerge';
import {updatePropertyPreferences} from 'api/propertyPreferences';

const UPDATE = 'pulp/indicativeSellingPrice/UPDATE';
const CLEAR_ERRORS = 'pulp/indicativeSellingPrice/CLEAR_ERRORS';

export const initialState = {
  sellingPriceType: 'single-price',
  singlePrice: null,
  priceRange: {
    min: null,
    max: null,
  },
  errors: {},
};

export default function reducer(state= initialState, action) {
  switch (action.type) {
    case UPDATE:
      return merge(state, action.payload);
    case CLEAR_ERRORS:
      return {...state, errors: {}};
    default:
      return state;
  }
}

export function updateIndicativeSellingPrice(payload, savePreference = false) {
  return (dispatch, getState) => {
    if (savePreference) {
      const {
        propertyDetail: {propertyId},
        indicativeSellingPrice: {errors, ...indicativeSellingPrice},
      } = getState();
      updatePropertyPreferences(propertyId, {indicativeSellingPrice: merge(indicativeSellingPrice, payload)});
    }

    dispatch({
      type: UPDATE,
      payload,
    });
  };
}

export function clearIndicativeSellingPriceErrors() {
  return {
    type: CLEAR_ERRORS,
  };
}
